import { render } from "./CustomerStatsComponent.vue?vue&type=template&id=1f6c5c3c"
import script from "./CustomerStatsComponent.vue?vue&type=script&lang=js"
export * from "./CustomerStatsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/dashboard/CustomerStatsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f6c5c3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f6c5c3c', __exports__)) {
    api.reload('1f6c5c3c', __exports__)
  }
  
  module.hot.accept("./CustomerStatsComponent.vue?vue&type=template&id=1f6c5c3c", () => {
    api.rerender('1f6c5c3c', render)
  })

}


export default __exports__